<router-outlet></router-outlet>

<div class="notification-container" id="notification" *ngIf="showWhatsappMsgPopup" #notificationElement>
    <div class="notification-header">
        <div class="notification-icon">💬</div>
        <div class="notification-title">{{msgContent?.notification?.title}}</div>
        <button class="notification-close" (click)="closeNotification()">×</button>
    </div>
    <div class="notification-body">
        <div class="notification-message">
            {{msgContent?.notification?.body}}
        </div>
        <div class="notification-meta">
            <!-- <div class="notification-from">From: 576816357859</div> -->
            <div class="notification-id">ID:  {{msgContent?.data?.conversationId}}</div>
            <!-- <div class="notification-id">See</div> -->
        </div>
    </div>
</div>